import React, { useState, useEffect } from "react";

import { Box, Button, Divider, Grid, Stack, TextField, Typography, TextareaAutosize, SnackbarOrigin, Snackbar } from "@mui/material";

import MuiAlert from '@mui/material/Alert';

import axios from "axios";

import { ToastContainer, toast } from 'react-toastify';

import FileAttachementButton from "./features/FileAttachementButton";

import 'react-toastify/dist/ReactToastify.css';

import { useLocation, useNavigate } from "react-router-dom";

import SendIcon from '@mui/icons-material/Send';

import { format } from 'date-fns';

import HistoryIcon from '@mui/icons-material/History';

import Historybutton from './features/Historybutton';

import CloseIcon from '@mui/icons-material/Close';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import moment from 'moment';



import Dialog from '@mui/material/Dialog';

import DialogActions from '@mui/material/DialogActions';

import DialogContent from '@mui/material/DialogContent';

import DialogContentText from '@mui/material/DialogContentText';

import DialogTitle from '@mui/material/DialogTitle';

import useMediaQuery from '@mui/material/useMediaQuery';

import { useTheme } from '@mui/material/styles';

import { configure } from './../config';





const config = {

    headers: {

        'Access-Control-Allow-Origin': '*',

        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',

        'Content-Type': 'text/plain',

        'Authorization': ""

    }

};

const Alert = React.forwardRef(function Alert(props, ref) {

    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;

});



const FileUploadPage = () => {
    var userProfile = JSON.parse(sessionStorage.getItem("userProfile"));
    var idToken = JSON.parse(sessionStorage.getItem("idToken"));
    console.log("idToken", idToken)
    console.log("userProfile", userProfile)
    const [stateMsg, setStateMsg] = React.useState({
        open: false,
        vertical: 'top',
        horizontal: 'center'
    });
    // const history = useNavigate()

    const navigate = useNavigate();


    const { vertical, horizontal, open } = stateMsg;

    const [severity, setSeverity] = useState("")

    const [width, setWidth] = useState("0%")

    const [msg, setMsg] = useState("")

    const [from, setFrom] = useState(userProfile.email)

    const [to, setTo] = useState("")

    const [cc, setCC] = useState("")

    const [expNme, setexpNme] = useState("");

    const [species, setspecies] = useState("");

    const [noOfCells, setnoOfCells] = useState("");

    const [noOfSamples, setnoOfSamples] = useState("");

    const [sampleNmes, setsampleNmes] = useState("");

    const [desc, setdesc] = useState("");

    const [comments, setcomments] = useState("");

    const [commentsList, setCommentsList] = useState([]);

    const [attachments, setattachement] = useState("attach");

    const [status, setStatus] = useState("New");

    const [isSave, setIsSave] = useState(false);

    const [isSubmit, setIsSubmit] = useState(false);

    const [isUpload, setIsUpload] = useState(true);

    const { state } = useLocation();

    const [dashboadData, setDashboard] = useState(state);

    const [dashboadNewData, setDashboardNew] = useState({});

    const [isNew, setIsNew] = useState(true);

    const [isClose, setIsClose] = useState(false);

    const [saved, setSaved] = useState(true);

    const [isBack, setIsBack] = useState(true);

    const [isView, setIsView] = useState(state && state.data && (state.data.experiment_status === "Saved" || state.isView) ? true : state ? false : null);

    var givenName = JSON.parse(sessionStorage.getItem("userProfile"));



    const [openDialog, setOpen] = React.useState(false);

    const theme = useTheme();

    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const [privileges, setPrivileges] = useState([]);
    let [selectedPrivilegesList, setSelectedPrivilegesList] = React.useState([]);


    // useEffect(() => {
    //     axios.get('https://o7qtx7i126.execute-api.us-west-2.amazonaws.com/dev/api/getPrivileges')
    //         .then(response => response.json)
    //         .then(data => setSelectedPrivilegesList({ selectedPrivilegesList: data }))
    //         .catch(err => console.log(err))
    // }, [])

    const handleClickOpen = () => {

        setOpen(true);

    };



    const handleClickClose = () => {

        setOpen(false);

    };



    const DialogClose = () => {

        CloseExperiment();

        setOpen(false);

    };







    //   function getSessionStorage(key) {

    //     const stored = sessionStorage.getItem(key);

    //     if (!stored) {

    //       return null;

    //     }

    //     return JSON.parse(stored);

    // const expData = history.location.state.data;



    // setStateMsg({ open: true, ...newState });





    var validateArray = [{

        experiment: '',

        species: '',

        noOfCells: '',

        noOfSamples: '',

        sampleNmes: '',

        desc: '',

        comments: '',

        to: ''

    }];

    const [getValidation, setValidation] = useState(validateArray)



    const validation = () => {
        validateArray = [];
        var validateObj = {
            experiment: '',
            species: '',
            noOfCells: '',
            noOfSamples: '',
            sampleNmes: '',
            desc: '',
            comments: '',
            to: ''
        }

        var errorMsg = "";
        if (!state) {
            if (expNme.trim().length === 0) {
                validateObj.experiment = "Experiment is required "
                errorMsg = validateObj.experiment + ","

            }
            if (species.trim().length === 0) {
                validateObj.species = " Species is required "
                errorMsg = errorMsg + validateObj.species + ","
            }
            if (noOfCells.trim().length === 0) {
                validateObj.noOfCells = " No.of cells is required "
                errorMsg = errorMsg + validateObj.noOfCells + ","

            }
            if (noOfSamples.trim().length === 0) {
                validateObj.noOfSamples = " No.of samples is required "
                errorMsg = errorMsg + validateObj.noOfSamples + ","
            }
            if (sampleNmes.trim().length === 0) {
                validateObj.sampleNmes = " Sample is required "
                errorMsg = errorMsg + validateObj.sampleNmes + ","
            }
            if (desc.trim().length === 0) {
                validateObj.desc = " Description is required "
                errorMsg = errorMsg + validateObj.desc + ","
            }
            if (to.trim().length === 0) {
                validateObj.to = " Mail is required "
                errorMsg = errorMsg + validateObj.to + ","
            }
        }
        '</html>'

        if (comments.trim().length === 0) {
            validateObj.comments = " Message/Remarks is required"
            errorMsg = errorMsg + validateObj.comments
        }

        validateArray.push(validateObj)
        setValidation(validateArray);
        setSeverity('error')
        setMsg(errorMsg)

        if (errorMsg) {
            setMsg(errorMsg);

            var newState = {
                vertical: 'top',
                horizontal: 'center',
            }
            setStateMsg({ open: true, ...newState });
        }

    }

    useEffect(() => {
        if (isUpload) {
            if (userProfile.nickname === "Bio-Rad" || userProfile.nickname === "BioRad" || userProfile.nickname === "Biorad") {
                sessionStorage.setItem("active", 'sideitem active');
            }
            else {
                sessionStorage.setItem("active", '');
            }
            sessionStorage.setItem("experimentID", null)
            if (state) {
                sessionStorage.setItem("experimentID", state.data.experiment_id)
                if (state.data.experiment_status === "Responded") {
                    setIsClose(false)
                }
                if (state.data.experiment_status === "Closed") {
                    setIsClose(true)
                }
                if (state.data.experiment_status !== "Saved") {
                    setIsNew(false)
                    setIsSubmit(true);
                    setIsView(false);
                    setIsBack(false);
                }
                else {
                    setIsSubmit(false);
                    setSaved(false);
                    setIsBack(false);
                }
                setStatus(state.data.experiment_status)
                setexpNme(state.data.experiment_name);
                setspecies(state.data.species);
                setnoOfCells(state.data.no_of_cells);
                setnoOfSamples(state.data.no_of_samples);
                setdesc(state.data.description);
                setsampleNmes(state.data.sample_name);
                setTo(state.data.to_mail);
                setIsSave(true);
                setIsUpload(false);
                commentsApi();
            }
        }
        else {
            setIsUpload(false);
        }
    }, [isUpload]);


    const commentsApi = async (req) => {
        const response = await fetch(`${configure.backendUrl}/comments`, {
            method: 'POST',
            body: JSON.stringify({ "Experiment_ID": state && state.data.experiment_id, "type": "View_Exp" }),
            headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
        });
        const responseData = await response.json();
        if (responseData && response.status === 200) {
            setCommentsList(responseData.data)
        }
    }



    const experimentData = async () => {
        var storedValue = sessionStorage.getItem('clickedInstrument')
        const typeData = JSON.stringify({ type: 'ViewAll', instrument: storedValue, company_name: userProfile.nickname });
        const response = await fetch(`${configure.backendUrl}/dynamodb`, {
            method: 'POST',
            body: typeData,
            headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
        });
        const responseData = await response.json();
        if (responseData && response.status === 200) {
            sessionStorage.setItem("experimentData", JSON.stringify(responseData));
            if (userProfile.nickname === "Bio-Rad" || userProfile.nickname === "BioRad" || userProfile.nickname === "Biorad") {
                sessionStorage.setItem("experimentData", JSON.stringify(responseData.filter(m => m.experiment_status !== "Saved")));
            }
            else {
                sessionStorage.setItem("experimentData", JSON.stringify(responseData));
            }
        }
    }

    const onsubmit = async () => {
        if (comments.trim().length === 0) {
            setSeverity('error')
            setMsg("Message is Blank! Please update...")
            var newState = {
                vertical: 'top',
                horizontal: 'center',
            }
            setStateMsg({ open: true, ...newState });
            return
        }
        var exp_id = JSON.parse(JSON.stringify(sessionStorage.getItem("experimentID")))
        const req_experimentDetail = {
            type: "Update",
            id: exp_id,
            experiment_status: 'Submitted',
            to_mail: to
        };
        const response = await fetch(`${configure.backendUrl}/dynamodb`, {
            method: 'POST',
            body: JSON.stringify(req_experimentDetail),
            headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
        });
        const responseData = await response.text();
        if (responseData && response.status === 200) {
            setStatus("Submitted");
            setIsSubmit(true);
            setIsUpload(false);
            setIsClose(false)
            setcomments("")
            var user = JSON.parse(sessionStorage.getItem("idToken"));
            var mailArray = []
            mailArray = to.split(',');
            mailArray.push(user.payload.email);
            var companyNames = user.payload.nickname;
            var request = {
                "email_body": '<html><head>' +
                    ' <title>Experiment</title>' +
                    ' </head>' +
                    ' <body>' +
                    '<label> ** Bio-Rad – Large File Data Transfer - System Generated Notification **   <br><br><br>' +
                    '        <u>Experiment Details</u> - [Submitted]<br><br>' +
                    comments + '<br><br><br>' +
                    '__________________________________________<br><br>' +
                    '        <label> Experimental Name: ' + expNme + '</label><br>' +
                    '        <label> Description : ' + desc + '</label><br>' +
                    '        <label> Species: ' + species + '</label><br>' +
                    '        <label> No.of Cells:' + noOfCells + '</label><br>' +
                    '        <label> No.of Samples:' + noOfSamples + '</label><br>' +
                    '__________________________________________<br><br>' +
                    '<label>*** End of Message ***</label>' +
                    ' </body>' +
                    ' </html>',
                "to_email": mailArray,
                "cc_name": '', //cc,
                "from_email": "notifications_LFTS@bio-rad.com", //user.email
                "subject": "LFDT Notification: " + companyNames + " - " + expNme
            }
            const responseEmail = await fetch(`${configure.backendUrl}/email`, {
                method: 'POST',
                body: JSON.stringify(request),
                headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
            });
            const responseData = await responseEmail.json();
            if (responseData && responseEmail.status === 200) {
                console.log(responseData)
            }
            experimentData();
            setSeverity('success')
            setMsg("Experiment data submitted successfully!")
            var newState = {
                vertical: 'top',
                horizontal: 'center',
            }
            setStateMsg({ open: true, ...newState });
        }
        const responseDB = await fetch(`${configure.backendUrl}/dynamodb`, {
            method: 'POST',
            body: JSON.stringify(req_experimentDetail),
            headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
        });
        const responseDBData = await responseDB.json();
        if (responseDBData && responseDB.status === 200) {
            toast.error('Error! Something went wrong...please try again!', {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        }

    }
    const onResponse = async (status) => {
        var dashboadNew = {};
        if(!state) {
            dashboadNew = JSON.parse(sessionStorage.getItem("dashboardNew"));
        }
        var exp_id = dashboadData ? dashboadData.data.experiment_id : dashboadNew.data.experiment_id;
        const req_experimentDetail = {
            type: "Update",
            id: exp_id,
            experiment_status: status,
            to_mail: to
        };
        const responseDB = await fetch(`${configure.backendUrl}/dynamodb`, {
            method: 'POST',
            body: JSON.stringify(req_experimentDetail),
            headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
        });
        const responseDBData = await responseDB.text();
        if (responseDBData && responseDB.status === 200) {
            setStatus(status);
            setIsSubmit(true);
            var user = JSON.parse(sessionStorage.getItem("userProfile"));
            experimentData();
            var user = JSON.parse(sessionStorage.getItem("userProfile"));
            var mailArray = []
            mailArray = to.split(',');
            mailArray.push(user.email);
            var companyNames = dashboadData ? dashboadData.data.company_name : user.nickname;
            var request = {
                "email_body": '<html><head>' +
                    ' <title>Experiment</title>' +
                    ' </head>' +
                    ' <body>' +
                    '<label> ** Bio-Rad – Large File Data Transfer - System Generated Notification **   <br><br><br>' +
                    '        <u>Experiment Details</u> - [' + status + ']<br><br>' +
                    comments + '<br><br><br>' +
                    '__________________________________________<br><br>' +
                    '        <label> Experimental Name: ' + expNme + '</label><br>' +
                    '        <label> Description : ' + desc + '</label><br>' +
                    '        <label> Species: ' + species + '</label><br>' +
                    '        <label> No.of Cells:' + noOfCells + '</label><br>' +
                    '        <label> No.of Samples:' + noOfSamples + '</label><br>' +
                    '__________________________________________<br><br>' +
                    '<label>*** End of Message ***</label>' +
                    ' </body>' +
                    ' </html>',
                "to_email": mailArray,
                "cc_name": '', //cc,
                "from_email": "notifications_LFTS@bio-rad.com", //user.email
                "subject": "LFDT Notification: " + companyNames + " - " + expNme
            }
            const responseEmail = await fetch(`${configure.backendUrl}/email`, {
                method: 'POST',
                body: JSON.stringify(request),
                headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
            });
            const responseData = await responseEmail.json();
            if (responseData) {
                console.log(responseData)
            }
            setSeverity('success')
            setMsg("Experiment data " + status + " successfully!")
            var newState = {
                vertical: 'top',
                horizontal: 'center',
            }
            setStateMsg({ open: true, ...newState });
        }
    }

    function OnCell(e) {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            setnoOfCells(e.target.value)
        }
    }
    function OnNoSamples(e) {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            setnoOfSamples(e.target.value)
        }
    }
    const commentsFunc = async () => {
        if (comments.length === 0) {
            setSeverity('error')
            setMsg("Message is Blank! Please update...")
            var newState = {
                vertical: 'top',
                horizontal: 'center',
            }
            setStateMsg({ open: true, ...newState });
            return
        }
        var user = JSON.parse(sessionStorage.getItem("userProfile"));
        var storedValue = sessionStorage.getItem('clickedInstrument')
        const experimentComments = {
            type: "Add",
            Experiment_ID: dashboadData.data.experiment_id,
            User_EmailID: user.email + ":" + givenName.given_name,
            Comments: comments,
            Company: user.nickname,
            Comments_Date: new Date(),
            instrument: storedValue
        };

        const response = await fetch(`${configure.backendUrl}/comments`, {
            method: 'POST',
            body: JSON.stringify(experimentComments),
            headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
        });
        const responseData = await response.text();
        if (responseData && response.status === 200) {
            setStatus("Submitted")
            setIsSubmit(true);
            console.log(response)
            if (isSubmit) {
                setStatus("Responded")
            }
            if (dashboadData && dashboadData.data.experiment_status === "Saved") {
                onResponse("Submitted")
            }
            if (dashboadData && dashboadData.data.experiment_status === "Submitted") {
                onResponse("Responded")
            }
            if (dashboadData && dashboadData.data.experiment_status === "Responded") {
                onResponse("Responded")
            }
            if (dashboadData && dashboadData.data.experiment_status === "Acknowledged") {
                onResponse("Closed")
            }

            const response_Comments = await fetch(`${configure.backendUrl}/comments`, {
                method: 'POST',
                body: JSON.stringify(experimentComments),
                headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
            });
            const responseMainComments = await response_Comments.text();
            if (responseMainComments  && response_Comments.status === 200) {
                const response_comments = await fetch(`${configure.backendUrl}/comments`, {
                    method: 'POST',
                    body: JSON.stringify({ "Experiment_ID": dashboadData && dashboadData.data.experiment_id, "type": "View_Exp" }),
                    headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
                });
                const responseDataComments = await response_comments.json();
                if (responseDataComments && response_comments.status === 200) {
                    setCommentsList(responseDataComments.data)
                    setcomments('');
                }
            }
        }
    }



    const CloseExperiment = async () => {
        if (comments.length === 0) {
            setSeverity('error')
            setMsg("Message is required")
            var newState = {
                vertical: 'top',
                horizontal: 'center',
            }
            setStateMsg({ open: true, ...newState });
            return
        }
        var user = JSON.parse(sessionStorage.getItem("userProfile"));
        var storedValue = sessionStorage.getItem('clickedInstrument')
        const experimentComments = {
            type: "Add",
            Experiment_ID: dashboadData.data.experiment_id,
            User_EmailID: user.email + ":" + givenName.given_name,
            Comments: comments,
            Company: user.nickname,
            Comments_Date: new Date(),
            instrument: storedValue
        };
        const response_comments_add = await fetch(`${configure.backendUrl}/comments`, {
            method: 'POST',
            body: JSON.stringify(experimentComments),
            headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
        });
        const responseDataCommentsAdd = await response_comments_add.text();
        if (responseDataCommentsAdd  && response_comments_add.status === 200) {
            onResponse("Closed")
            setIsClose(true);
            const response_comments = await fetch(`${configure.backendUrl}/comments`, {
                method: 'POST',
                body: JSON.stringify({ "Experiment_ID": dashboadData && dashboadData.data.experiment_id, "type": "View_Exp" }),
                headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
            });
            const responseDataComments = await response_comments.json();
            if (responseDataComments && response_comments.status === 200) {
                setCommentsList(responseDataComments.data)
                setcomments('');
            }
        }
    }



    const handleClose = () => {

        setStateMsg({ ...stateMsg, open: false });

    };





    const openSlide = () => {

        setWidth('81.5%');

    };

    const closeSlide = () => {

        setWidth('0%');

    };







    var storedValue = sessionStorage.getItem('clickedInstrument')




    const handleSave = async () => {
        validation();
        console.log(getValidation);
        var user = JSON.parse(sessionStorage.getItem("userProfile"));

        if (expNme.trim().length === 0 || species.trim().length === 0 || noOfCells.trim().length === 0 || noOfSamples.trim().length === 0 || sampleNmes.trim().length === 0 || to.trim().length === 0) {
            setSeverity('error')
            // setMsg(errorMsg)
            var newState = {
                vertical: 'top',
                horizontal: 'center',
            }
            setStateMsg({ open: true, ...newState });
            return
        }
        if (desc.length === 0) {

            return
        }
        if (comments.length === 0) {
            return
        }
        var storedValue = sessionStorage.getItem('clickedInstrument')
        var exp_id = moment(new Date()).format("YYMMDDhhmmssSSS")
        const experimentDetail = {
            type: "Add",
            id: exp_id.toString(),
            experiment_name: expNme,
            species: species,
            no_of_cells: noOfCells,
            no_of_samples: noOfSamples,
            sample_name: sampleNmes,
            description: desc,
            comments: "testComments",
            attachments: "test",
            experiment_status: 'Saved',
            experiment_date: new Date(),
            company_name: user.nickname,
            to_mail: to,
            cc_mail: cc,
            instrument: storedValue
        };
        const response = await fetch(`${configure.backendUrl}/dynamodb`, {
            method: 'POST',
            body: JSON.stringify(experimentDetail),
            headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
        });
        const responseData = await response.text();
        if (responseData && response.status === 200) {
            setStatus("Saved");
            sessionStorage.setItem("dashboardNew",JSON.stringify({
                data: {
                    experiment_id: experimentDetail.id
                }
            }))
            setDashboard({
                data: {
                    experiment_id: experimentDetail.id
                }
            });
           
            sessionStorage.setItem("experimentID", experimentDetail.id)
            setIsUpload(false)
            setIsSave(true);
            setIsSubmit(false);
            var storedValue = sessionStorage.getItem('clickedInstrument')
            const experimentComments = {
                type: "Add",
                Experiment_ID: experimentDetail.id,
                User_EmailID: user.email + ":" + givenName.given_name,
                Comments: comments,
                Company: user.nickname,
                Comments_Date: new Date(),
                instrument: storedValue
            };
            const response_comments_add = await fetch(`${configure.backendUrl}/comments`, {
                method: 'POST',
                body: JSON.stringify(experimentComments),
                headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
            });
            const responseDataCommentsAdd = await response_comments_add.text();
            if (responseDataCommentsAdd && response_comments_add.status === 200) {
                const response_comments = await fetch(`${configure.backendUrl}/comments`, {
                    method: 'POST',
                    body: JSON.stringify({ "Experiment_ID": experimentDetail.id, "type": "View_Exp" }),
                    headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
                });
                const responseDataComments = await response_comments.json();
                if (responseDataComments && response_comments.status === 200) {
                    setCommentsList(responseDataComments.data)
                }
            }
            setSeverity('success')
            setMsg("Experiment data saved successfully!")
            var newState = {
                vertical: 'top',
                horizontal: 'center',
            }
            setStateMsg({ open: true, ...newState });
            experimentData();
        }
    };
    const handleButtonCheck = () => {
        onsubmit();
        commentsFunc();
    }
    return (
        <>
            <div style={{ "width": "45px", "height": "100%", "background-color": "rgb(21 133 65)", "right": "0px", "position": "fixed" }}>
                <div style={{ "width": "180px", "height": "30px", color: "#fff" }}>
                    {
                        width === "0%" ?
                            <Button disabled={dashboadData ? false : true} sx={{ minWidth: '25px !important', color: "#fff", padding: "12px" }} onClick={openSlide} startIcon={<HistoryIcon style={{ "font-size": "27px" }} />} />
                            :
                            <Button sx={{ minWidth: '25px !important', color: "#fff", padding: "12px" }} onClick={closeSlide} startIcon={<ChevronRightIcon style={{ "font-size": "27px" }} />} />
                    }
                </div>
            </div>
            <div id="mySidepanel" className="sidepanel" style={{ width: width, "margin-right": "45px" }}>
                <div className="form-row" style={{ "display": "flex" }}>

                    <div className="form-column" style={{ "width": "95%" }}>

                        <Button sx={{ minWidth: '25px !important' }} onClick={closeSlide} startIcon={<CloseIcon />} />

                        <div class="container">

                            <div class="row">

                                <div class="col-12">

                                    <div class="chat-area1">

                                        <div class="chatbox1">

                                            <div class="modal-dialog-scrollable">

                                                <div class="modal-content">

                                                    <div class="modal-body">

                                                        <div class="msg-body" style={{ "height": "35.5vw" }}>

                                                            <ul>

                                                                {commentsList && commentsList.map(function (name, index) {



                                                                    return <li className={userProfile.nickname === "Bio-Rad" ? ((name.Company !== "Bio-Rad" || name.Company !== "Bio-Rad") ? 'sender' : 'replay') : ((name.Company === "Bio-Rad" || name.Company === "Bio-Rad") ? 'replay' : 'sender')} >

                                                                        <p> {name.Comments} </p>

                                                                        <span class="time">{format(new Date(name.Comments_Date), 'dd-MMM-yy hh:mm')}, {name.User_EmailID.split(":").length === 2 ? name.User_EmailID.split(":")[1] : ""}</span>

                                                                    </li >

                                                                })}



                                                            </ul>

                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                    </div>





                                </div>

                            </div>

                        </div>

                    </div>

                    <div className="form-column"></div>



                </div>



            </div>

            <Grid flex={3} p={1} sx={{ boxShadow: 2, marginRight: 1, maxHeight: 1, marginTop: 0.5 }}>

                <Stack direction={"column"}  >

                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: -1 }}>

                        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', marginLeft: 1 }}>

                            <Typography fontWeight={500} fontSize={22} color="text.secondary">Experiment Details </Typography>

                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'flex-end', alignContent: 'center', marginLeft: '10' }}>

                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: 3 }}>

                                <Typography fontWeight={500} fontSize={15} color="text.secondary" sx={{ marginRight: 1 }} >Status:</Typography>

                                {console.log(state?.data?.experiment_status, "status")}

                                <Typography fontWeight={500} fontSize={17} color="#4336F4"

                                    sx={{ marginRight: 4.5 }}>{state ? state.data.experiment_status : status}</Typography>

                            </Box>

                            {/* {isUpload ? <Button disabled="true" variant="contained" color="success" sx={{ width: 140, borderRadius: 2 }}>Attachment</Button> : <FileAttachementButton />} */}

                        </Box>

                    </Box>

                    <Box sx={{ marginTop: 0.5 }}>

                        <Divider sx={{ bgcolor: "#bdbdbd", borderBottomWidth: 1 }} />

                    </Box>

                    <Grid sticky sx={{ flexDirection: 'column' }} >

                        <div style={{ "height": "70vh", "overflow-y": "auto" }}>

                            <div className="form-row" style={{ "display": "flex" }}>

                                <div className="form-column" style={{ "padding": "6px", "padding-bottom": "0px", "width": "55.8%" }}>

                                    <Grid item >

                                        <Box sx={{ flexDirection: 'column', marginTop: 0.5 }} >

                                            <Typography fontSize={15} value="experimentName">

                                                Experiment Name {getValidation[0].experiment ? <span style={{ "color": "red" }}>*</span> : '*'}

                                            </Typography>

                                            <TextField size="small" disabled={isSave} value={expNme} onChange={(e) => { setexpNme(e.target.value) }} sx={{ width: '100%', color: '#e0e0e0', borderColor: 'gray.500' }} inputProps={{ style: { height: "15px" } }}>

                                            </TextField>

                                            {/* <label for="validationError" class="form-label text-danger">{getValidation[0].experiment}</label> */}

                                        </Box>

                                    </Grid>

                                    <Grid item>

                                        <Box sx={{ flexDirection: 'column' }}>

                                            <Typography fontSize={15}>

                                                Species  {getValidation[0].species ? <span style={{ "color": "red" }}>*</span> : '*'}

                                            </Typography>

                                            <TextField size="small" disabled={isSave} value={species} onChange={(e) => { setspecies(e.target.value) }} sx={{ width: '100%' }} inputProps={{ style: { height: "15px" } }}>

                                            </TextField>

                                            {/* <label for="validationError" class="form-label text-danger">{getValidation[0].species}</label> */}

                                        </Box>

                                    </Grid>

                                    <Grid item>

                                        <Grid container sx={{ flexDirection: 'row' }} spacing={2} >

                                            <Grid item sx={{ width: "33.3%" }}>

                                                <Box sx={{ flexDirection: "column", display: "flex" }}>

                                                    <Typography fontSize={15}>

                                                        No. of Cells {getValidation[0].noOfCells ? <span style={{ "color": "red" }}>*</span> : '*'}

                                                    </Typography>

                                                    <TextField size="small" disabled={isSave} value={noOfCells} onChange={(e) => { OnCell(e) }} inputProps={{ style: { height: "15px" } }}>

                                                    </TextField>

                                                    {/* <label for="validationError" class="form-label text-danger">{getValidation[0].noOfCells}</label> */}

                                                </Box>

                                            </Grid>

                                            <Grid item sx={{ width: "33.3%" }}>

                                                <Box sx={{ flexDirection: "column", display: "flex" }}>

                                                    <Typography fontSize={15}>

                                                        No. of Samples {getValidation[0].noOfSamples ? <span style={{ "color": "red" }}>*</span> : '*'}

                                                    </Typography>

                                                    <TextField size="small" disabled={isSave} value={noOfSamples} onChange={(e) => { OnNoSamples(e) }} inputProps={{ style: { height: "15px" } }}>

                                                    </TextField>

                                                    {/* <label for="validationError" class="form-label text-danger">{getValidation[0].noOfSamples}</label> */}

                                                </Box>

                                            </Grid>

                                            <Grid item sx={{ width: "33.3%" }}>

                                                <Box sx={{ flexDirection: "column", display: "flex" }}>

                                                    <Typography fontSize={15}>

                                                        Sample Names {getValidation[0].sampleNmes ? <span style={{ "color": "red" }}>*</span> : '*'}

                                                    </Typography>

                                                    <TextField size="small" disabled={isSave} value={sampleNmes} onChange={(e) => { setsampleNmes(e.target.value) }} sx={{ width: '100%' }} inputProps={{ style: { height: "15px" } }}>

                                                    </TextField>

                                                    {/* <label for="validationError" class="form-label text-danger">{getValidation[0].sampleNmes}</label> */}

                                                </Box>

                                            </Grid>

                                        </Grid>

                                    </Grid>

                                </div>

                                <div className="form-row" style={{ "display": "flex" }}>

                                    <div className="form-column" style={{ "padding": "10px", "padding-top": "7px" }}>

                                        <Grid item>

                                            <Box sx={{ flexDirection: 'column', display: 'flex', marginTop: 0.5 }}>

                                                <Typography fontSize={15}>

                                                    Description {getValidation[0].desc ? <span style={{ "color": "red" }}>*</span> : '*'}

                                                </Typography>

                                                <TextareaAutosize value={desc} disabled={isSave} onChange={(e) => { setdesc(e.target.value) }} style={{ width: '30.2vw', height: '25.4vh' }} >

                                                </TextareaAutosize>

                                                {/* <label for="validationError" class="form-label text-danger">{getValidation[0].desc}</label> */}

                                            </Box>

                                        </Grid>

                                    </div>

                                </div>



                            </div>

                            <div className="form-row" style={{ "display": "flex" }}>

                                {/* <div className="form-row" style={{ "padding-bottom": "15px", "padding-left": "7px", "padding-right": "1px", "width": "70.5vw","padding-top":"2px" }}> */}

                                <div className="form-column" style={{ "width": "96.5%" }}>

                                    <Grid item>

                                        {/* <div style={{ "display": "flex", "justify-content": "space-between" }}> */}

                                        <Box sx={{ flexDirection: 'column', display: 'flex' }}>

                                            <Typography fontSize={15} style={{ marginBottom: 0.5 }}>

                                                Message/Remarks {getValidation[0].comments ? <span style={{ "color": "red" }}>*</span> : '*'}

                                            </Typography>

                                            {/* {dashboadData &&

                                            <Historybutton data={commentsList}></Historybutton>

                                        } */}



                                            {/* </div> */}



                                            {/* <div class="container">

                                        <div class="row">

                                            <div class="col-12">

                                                <div class="chat-area">

                                                    <div class="chatbox">

                                                        <div class="modal-dialog-scrollable">

                                                            <div class="modal-content"> */}

                                            {/* <div class="modal-body">

                                                                    <div class="msg-body" >

                                                                        <ul>

                                                                            {commentsList && commentsList.map(function (name, index) {

                                                                                return <li className={userProfile.nickname === "Bio-Rad" ? ((name.Company !== "Bio-Rad" || name.Company !== "Bio-Rad") ? 'sender' : 'replay') : ((name.Company === "Bio-Rad" || name.Company === "Bio-Rad") ? 'replay' :'sender')} >

                                                                                    <p> {name.Comments} </p>

                                                                                    <span class="time">{format(new Date(name.Comments_Date), 'dd-MMM-yy')}</span>

                                                                                </li >

                                                                            })}

                                                                           

 

                                                                        </ul>

                                                                    </div>

                                                                </div> */}



                                            {/* <div class="send-box" style={isView === false ? { "flex-direction": "row" } : { "flex-direction": "column" }}> */}



                                            {/* <input type="text" class="form-control" value={comments} disabled={isView ? isSave : false} onKeyUp={validation} onChange={(e) => { setcomments(e.target.value) }} aria-label="message…" placeholder="Write message…"></input> */}



                                            {/* <TextField value={comments} disabled={isSave} onKeyUp={validation} onChange={(e) => { setcomments(e.target.value) }} className="form-control">

                                                                    </TextField>  */}

                                            <div >

                                                <TextareaAutosize value={comments}

                                                    //  disabled={isView && saved ? isSave : isClose ? true : false}

                                                    onChange={(e) => { setcomments(e.target.value) }} style={{ width: '98%', height: '23vh' }} >

                                                </TextareaAutosize>



                                            </div>

                                        </Box>

                                    </Grid>

                                    {/* <label for="validationError" class="form-label text-danger">{getValidation[0].comments}</label> */}







                                    {/* </div> */}

                                    {/* </div>

                                                        </div>

                                                    </div>

                                                </div>

 

 

                                            </div>

                                        </div>

                                    </div> */}



                                    <Grid item>

                                        <Grid container sx={{ flexDirection: 'row', }}>

                                            <Grid item sx={{ width: "98%" }}>

                                                <Box sx={{ flexDirection: "column", display: "flex" }}>

                                                    <Typography fontSize={15}>

                                                        Distribution (<i><b>eMail separated by ,</b></i>) {getValidation[0].to ? <span style={{ "color": "red" }}>*</span> : '*'}

                                                    </Typography>

                                                    <TextField size="small" disabled={isClose ? true : false} type={'email'} value={to} onChange={(e) => { setTo(e.target.value) }} inputProps={{ style: { height: "15px" } }}>

                                                    </TextField>

                                                    {/* <label for="validationError" class="form-label text-danger">{getValidation[0].noOfSamples}</label> */}

                                                </Box>

                                            </Grid>





                                        </Grid>

                                    </Grid>







                                    {/* <Grid item>

                                    <Grid container sx={{ flexDirection: 'row', }} spacing={1}>

                                    <Grid item sx={{ width: "50%" }}>

                                                <Box sx={{ flexDirection: "column", display: "flex" }}>

                                                   

                                                    <Typography fontSize={15}>

                                                        From

                                                    </Typography>

                                                    <TextField size="small" disabled value={from} onChange={(e) => { setFrom(e.target.value) }} inputProps={{ style: { height: "15px" } }}>

                                                    </TextField>

                                                    {/* <label for="validationError" class="form-label text-danger">{getValidation[0].noOfSamples}</label> */}

                                    {/* </Box>

                                               

                                            </Grid>

                                            <Grid item sx={{ width: "50%" }}>

                                            <Box sx={{ flexDirection: "column", display: "flex" }}>

                                                   

                                                   <Typography fontSize={15}>

                                                       Cc

                                                   </Typography>

                                                   <TextField size="small" disabled value={cc} onChange={(e) => { setCC(e.target.value) }} inputProps={{ style: { height: "15px" } }}>

                                                   </TextField>

                                               </Box>

                                               </Grid>

                                    </Grid>

                                   </Grid> */}

                                    {/* </div>    */}

                                </div>

                            </div>

                        </div>









                        {/* <Grid item>

                            {/* <Box sx={{flexDirection:"column"}} >

                            <Typography fontSize={15}>

                                Comments

                            </Typography>

                            <TextField value={comments} disabled={isSave} onKeyUp={validation} onChange={(e)=>{setcomments(e.target.value)}}  multiline rows={5} size="small" sx={{ width:'100%'}} inputProps={{style:{height:"90px"}}}>

                            </TextField>

                            <label for="validationError" class="form-label text-danger">{getValidation[0].comments}</label>

                        </Box> */}





                        {/* </Grid> */}

                        <Grid item>

                            <Box display={'flex'} sx={{ justifyContent: 'flex-end', width: '74vw' }}>

                                <Box display={'flex'} sx={{ width: 396.5, gap: "6px", marginTop: 3 }}>

                                    {/* <Button size="medium" variant="outlined" sx={{width:100}}>Cancel</Button> */}

                                    <Button size="medium" variant="contained" color="success" sx={{ width: 100 }} disabled={isSave} onClick={handleSave}>Save</Button>

                                    <Button size="medium"

                                        // disabled={isNew ? true : false}

                                        variant="contained" color="success" sx={{ width: 100 }} onClick={() => navigate("/dashboard")}>Back</Button>



                                    {isView === false &&

                                        <div>



                                            <Button size="medium" variant="contained" color="success" disabled={isClose ? true : false} sx={{ width: 85 }} onClick={commentsFunc} >

                                                {

                                                    dashboadData.data.experiment_status === "Submitted" ? 'Respond' : dashboadData.data.experiment_status === "Responded" ? 'Respond' :

                                                        'Submit'

                                                }

                                            </Button>



                                        </div>



                                    }



                                    {/* {isNew &&



                                        <Button size="medium" variant="contained" disabled={isSave ? false : true}

                                            onClick={isSubmit ? onsubmit : commentsFunc} sx={{ width: 120 }} >



                                            {isSubmit ? 'Respond' : 'Submit'}

                                            {isSubmit ? 'Respond' : 'Submit'}

                                        </Button>

                                    } */}




                                    {isNew &&



                                        <Button size="medium" variant="contained" disabled={isSave ? false : true} onClick={handleButtonCheck} sx={{ width: 120 }} > {isSubmit ? 'Respond' : 'Submit'} </Button>

                                    }





                                    {isClose ? <div style={{ justifyContent: 'space-between', gap: "6px", display: "flex" }}>

                                        {userProfile.nickname === "Bio-Rad" ?

                                            <Button disabled="true" variant="contained" color="success" sx={{ width: 150 }}>Respond</Button> : ''}

                                        <Button disabled="true" variant="contained" color="success" sx={{ width: 110 }}>Attachments</Button>



                                    </div> :

                                        <div>

                                            {isUpload ? <Button disabled="true" variant="contained" color="success" sx={{ width: 120 }}>Attachments</Button> : <FileAttachementButton />}



                                        </div>

                                    }

                                    {userProfile.nickname !== "Bio-Rad" ?

                                        // <Button size="medium" variant="contained" disabled={status === "Responded" ? false : true} color="success" sx={{ width: 110 }} onClick={} >Close</Button>



                                        <Button disabled={(!isClose && isSubmit && isSave) ? false : true} onClick={handleClickOpen} variant="contained" color="success" sx={{ width: 30, color: '#fff', alignItems: 'center', minWidth: '60px !important' }} >Close</Button>



                                        : <Button disabled={true} variant="contained" color="success" sx={{ width: 30, color: '#fff', alignItems: 'center', minWidth: '60px !important' }} >Close</Button>}



                                </Box>

                            </Box>

                        </Grid>

                    </Grid>

                </Stack>

            </Grid>

            {/* <div>
            privileges

                <ul>
                    {selectedPrivilegesList.map((list,index)=>(
                        <li key={index}>{list.privilegesList}</li>
                    ))}
                </ul>
            </div> */}

            <Dialog

                fullScreen={fullScreen}

                open={openDialog}

                onClose={handleClickClose}

                aria-labelledby="responsive-dialog-title"

            >
                <DialogTitle id="responsive-dialog-title">

                    {"Confirmation"}

                </DialogTitle>

                <DialogContent>

                    <DialogContentText>

                        Further support for the experiment will be closed.

                        Are you sure you want to close this experiment?

                    </DialogContentText>

                </DialogContent>

                <DialogActions>

                    <Button autoFocus onClick={DialogClose}>

                        Yes

                    </Button>

                    <Button onClick={handleClickClose} autoFocus>
                        No
                    </Button>

                </DialogActions>
            </Dialog>



            <Snackbar

                anchorOrigin={{ vertical, horizontal }}

                open={open}

                autoHideDuration={3000}

                onClose={handleClose}

                key={vertical + horizontal}

            >
                <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
                    {msg}
                </Alert>
            </Snackbar>
        </>
    )

}
export default FileUploadPage;